<template>
	<div class="mutual-groups-wrapper">
		<div v-if="profilecard" class="mutual-groups-header">
			{{ $t('settings_common_groups_title') }}
		</div>

		<div class="mutual-groups-list">
			<div
				v-for="group in sorted"
				class="mutual-group"
				@click="changeGroup(group)"
			>
				<div class="category-title">
					{{ categoryTitle(group) }}
				</div>
				<div class="mutual-group-title pointer">
					{{ chatTitle(group) }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store, { getRecentChats, getChat } from '@/store'
import { post } from '@/helpers/api'
import { addEscapeListener, removeEscapeListener } from '@/helpers/escape'

export default {
	props: [
		'partner_id',
		'profilecard',
		'profileMutualgroups',
		'profileHiddengroups',
	],

	data() {
		return {
			store,
			hiddenGroups: [],
			mutualgroups: [],
		}
	},

	emits:['close'],

	created() {
		if (!this.profilecard) {
			this.getMutualGroups()
		} else {
			this.mutualgroups = this.profileMutualgroups
			this.hiddenGroups = this.profileHiddengroups
		}
	},

	mounted() {
		this.escapeId = addEscapeListener(() => {
			this.$emit('close')
		})
	},

	beforeUnmount() {
		removeEscapeListener(this.escapeId)
	},

	computed: {
		sorted() {
			return this.mutualgroups.sort((a, b) => {
				if (a.category === null) return 1
				if (b.category === null) return -1

				if (a.category.title == b.category.title) return 0

				if (a.category.title < b.category.title) return -1
				if (a.category.title > b.category.title) return 1

				return 0
			})
		},
	},

	methods: {
		categoryTitle(group) {
			if (!group.category)
				return this.$t('chat_drawer_section_bubbles_uncatagorized')

			return group.category && group.category.usercategory
				? group.category.usercategory.alias
				: group.category.title
		},

		changeGroup(group) {
			this.pushToRoute(group.id)
		},

		pushToRoute(id) {
			let isRecent = getRecentChats().find((x) => x.id === id)
			let path
			if (isRecent) {
				path = `/recents/${id}`
			} else {
				path = `/chat/${id}`
			}
			if (this.$route.path !== path) this.$router.push(path)

			if (this.profilecard) {
				EventBus.$emit('closeProfileCard')
			}
		},

		getMutualGroups() {
			post('/api/v1/user.mutualgroups', { user_id: this.partner_id })
				.then(({ data }) => {
					this.mutualgroups = data.bubbles

					this.hiddenGroups = data.memberships
						.filter((m) => m.ishidden)
						.map((m) => m.bubble_id)
				})
				.catch((error) => {
					console.error(error)
				})
		},

		chatTitle(chat) {
			return getChat(chat.id).displayname
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.mutual-groups-wrapper {
	border-radius: 15px;
	height: 100vh;
	overflow: scroll;
	padding-bottom: 20px;
	background: var(--neutral-0);
}

.mutual-groups-list {
	height: calc(100vh - 200px);
	overflow-y: auto;
	overflow-x: hidden;
}

.mutual-groups-header {
	font-family: Avenir-Heavy;
	font-size: 22px;
	color: var(--neutral-800);
	padding-top: 15px;
	margin-bottom: 21px;
	word-break: break-word;
	text-align: center;
}

.category-title {
	font-family: Avenir;
	color: var(--neutral-800);
	font-size: 10px;
	@include ellipsis;
	text-transform: uppercase;
	width: 100%;
	padding: 0 20px;
	margin-bottom: 5px;
}

.mutual-group-title {
	margin: 0 auto;
	font-family: Avenir-Heavy;
	font-size: 15px;
	color: var(--neutral-800);
	@include ellipsis;
	position: relative;
	padding: 0 20px;
}

.mutual-group {
	cursor: pointer;
	padding: 10px 0;
	border-radius: 12px;
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.mutual-groups-wrapper {
		background: var(--neutral-300);

		.mutual-group:hover {
			background-color: var(--neutral-200);
		}
	}
}
</style>
